import { Language } from "@vw-marketing/vw-ca-types";
import { useFeatureServices } from "../use-feature-services";

export const getLang = () => {
  const { language } = useFeatureServices()['locale-service'];
  return language as Language;
}

export default (lang : Language) => {
    const copies = require('./' + lang + '.json');

    return {
        ...copies,
    }
}
